function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.124 51.893H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 33.062H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 14.231H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.029,
  cy: 11.463,
  r: 4.029
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.029,
  cy: 30.062,
  r: 4.029
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.029,
  cy: 48.661,
  r: 4.029
});
function SvgDetailedFormat(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60.123 60.123",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "ff4a52cd30cc89d75615d86d5dd1845e.svg";
export { SvgDetailedFormat as ReactComponent };